import { useOffersInfiniteQuery } from '../../../hooks/useOffersInfiniteQuery';
import { useOffersListingInfiniteQuery } from './useOffersListingInfiniteQuery';
const PAGE_SIZE = 20;
export const useUnifiedInfiniteOffers = (source, query, params, options) => {
    if (source === 'offers') {
        const { offersInfiniteQuery } = useOffersInfiniteQuery({
            size: PAGE_SIZE,
            q: query && query.length > 2 ? query : undefined,
            ...params,
        }, {
            keepPreviousData: true,
            ...options,
        });
        const pages = offersInfiniteQuery.data?.pages.map((p) => ({
            items: p.offers.map((o) => ({
                id: o.id,
                name: o.name,
                image: o.primaryImage?.thumbnail.url,
                state: o.state.status,
                variants: (o.variants || []).map((v) => ({
                    id: v.id,
                    name: v.attributesDescription,
                    color: v.colorAttribute?.colorSwatch
                        ? { label: v.colorAttribute.name, value: v.colorAttribute.colorSwatch }
                        : undefined,
                })),
                hasHsCode: Boolean(o.customsInformation?.shortHsCode),
                available: o.state.available,
            })),
            page: p.page,
        }));
        return {
            products: pages?.map((p) => p.items).flat(),
            hasNextPage: offersInfiniteQuery.hasNextPage,
            isLoading: offersInfiniteQuery.isLoading,
            fetchNextPage: offersInfiniteQuery.fetchNextPage,
        };
    }
    const { query: listingQuery } = useOffersListingInfiniteQuery({
        size: PAGE_SIZE,
        q: query && query.length > 2 ? query : undefined,
        ...params,
    }, options);
    const pages = listingQuery.data?.pages.map((p) => ({
        items: p.offers.map((o) => ({
            id: o.id,
            name: o.name,
            image: o.thumbnail,
            state: o.status,
            variants: [],
            hasHsCode: false,
            available: o.stock.type !== 'SOLD_OUT',
        })),
        page: p.page,
    }));
    return {
        products: pages?.map((p) => p.items).flat(),
        hasNextPage: listingQuery.hasNextPage,
        isLoading: listingQuery.isLoading,
        fetchNextPage: listingQuery.fetchNextPage,
    };
};
